<script setup lang="ts">
defineProps<{
  retrying?: boolean
}>()

const emit = defineEmits<{
  retry: []
}>()
</script>

<template>
  <main class="subscription-expired" aria-labelledby="expired-title">
    <section class="subscription-expired__card" aria-live="polite">
      <div class="subscription-expired__status" aria-hidden="true">403</div>
      <p class="subscription-expired__eyebrow">پورتیفای</p>
      <h1 id="expired-title" class="subscription-expired__title">
        این سایت موقتاً در دسترس نیست
      </h1>
      <p class="subscription-expired__message">
        اشتراک این سایت به پایان رسیده است. مدیر سایت می‌تواند با تمدید اشتراک،
        دوباره آن را در دسترس قرار دهد.
      </p>
      <div class="subscription-expired__actions">
        <button
          type="button"
          class="subscription-expired__retry"
          :disabled="retrying"
          @click="emit('retry')"
        >
          {{ retrying ? 'در حال بررسی...' : 'بررسی دوباره' }}
        </button>
      </div>
    </section>
  </main>
</template>

<style scoped>
.subscription-expired {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: grid;
  min-height: 100dvh;
  place-items: center;
  overflow: auto;
  padding: 24px;
  color: #25282d;
  background:
    radial-gradient(circle at 50% 0%, #ffffff 0, transparent 42%),
    #f4f5f6;
}

.subscription-expired__card {
  display: grid;
  width: min(100%, 520px);
  justify-items: center;
  padding: clamp(32px, 7vw, 56px);
  border: 1px solid #e0e2e4;
  border-radius: 18px;
  background: rgb(255 255 255 / 82%);
  box-shadow: 0 20px 60px rgb(37 40 45 / 8%);
  text-align: center;
}

.subscription-expired__status {
  display: grid;
  min-width: 64px;
  height: 36px;
  place-items: center;
  border: 1px solid #b8bcc1;
  border-radius: 999px;
  color: #555a61;
  font-size: 13px;
  font-weight: 800;
  letter-spacing: 0.08em;
}

.subscription-expired__eyebrow {
  margin-top: 24px;
  color: #8a8f96;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.08em;
}

.subscription-expired__title {
  margin-top: 10px;
  color: #25282d;
  font-size: clamp(24px, 6vw, 34px);
  font-weight: 800;
  line-height: 1.45;
}

.subscription-expired__message {
  max-width: 390px;
  margin-top: 16px;
  color: #696f77;
  font-size: 14px;
  line-height: 2;
}

.subscription-expired__actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px;
  margin-top: 28px;
}

.subscription-expired__retry {
  border-radius: 8px;
  padding: 11px 22px;
  font: inherit;
  font-size: 13px;
  font-weight: 700;
  transition: transform 0.2s ease, background-color 0.2s ease;
}

.subscription-expired__retry {
  border: 1px solid #c8ccd0;
  color: #30343a;
  background: #ffffff;
  cursor: pointer;
}

.subscription-expired__retry:hover:not(:disabled) {
  transform: translateY(-1px);
}

.subscription-expired__retry:hover:not(:disabled) {
  border-color: #8c9198;
  background: #eceeef;
}

.subscription-expired__retry:focus-visible {
  outline: 3px solid rgb(48 52 58 / 25%);
  outline-offset: 3px;
}

.subscription-expired__retry:disabled {
  cursor: wait;
  opacity: 0.65;
}

@media (max-width: 480px) {
  .subscription-expired {
    padding: 16px;
  }

  .subscription-expired__card {
    padding-inline: 24px;
  }

  .subscription-expired__actions,
  .subscription-expired__retry {
    width: 100%;
  }
}

@media (prefers-reduced-motion: reduce) {
  .subscription-expired__retry {
    transition: none;
  }
}
</style>
